import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Home from "./Home/Home";
import Services from "./Services/Services";
import Products from "./Products/Products";
import Portfolio from "./Portfolio/Portfolio";
import Blogs from "./Blog/Blog";
import Contact from "./Contact/Contact";
import TestimonialDisplay from "./testimonials/testimonials";
import Statics from "./Statics/Statics";
import Gap from "./Gap";
import AboutUs from "./AboutUs/AboutUs";

const LandingPage = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  }, [hash]);

  return (
    <>
      <section id="home">
        <Home />
      </section>

      <section id="services">
        <Services />
      </section>
      <Gap />

      <section id="products">
        <Products />
      </section>
      <Gap />
      <Statics />

      <section id="portfolio">
        <Portfolio />
      </section>
      <Gap />

      <section id="blog">
        <Blogs />
      </section>
      <Gap />

      <section id="testimonials">
        <TestimonialDisplay />
      </section>
      <Gap />

      <section id="contact">
        <Contact />
      </section>
    </>
  );
};

export default LandingPage;
